import {inject} from '@angular/core';
import {CanActivateFn, Router, UrlTree} from '@angular/router';
import {StorageService} from "./storage.service";
import {ToastService} from "./toast.service";

export const kioskGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
  const storage = inject(StorageService);
  const router = inject(Router);
  const toast = inject(ToastService);

  const user = await storage.getUser();
  if (!user) {
    return true;
  } else {
    await toast.present(
      'Cannot switch users while signed in. Please sign out and try again.',
      5000,
      'middle',
    );
    // Return a UrlTree to redirect
    return router.createUrlTree(['/home']);
  }
};

